import { ModalController } from "@ionic/angular";
import { Component, OnInit } from "@angular/core";
import { AppService } from "../../app.service";
import { UTILITIES } from "../../core/utility/utilities";
import moment from "moment";
import { Storage } from "@ionic/storage";

@Component({
  selector: "app-select-plan-popup",
  templateUrl: "./select-plan-popup.component.html",
  styleUrls: ["./select-plan-popup.component.scss"],
})
export class SelectPlanPopupComponent implements OnInit {
  planType;
  plan;
  isPremium;
  note;
  isOnlyInfo;
  constructor(public modalController: ModalController, private appService: AppService, private utilities: UTILITIES,private storage: Storage,) { }

  ngOnInit() {
    console.log("Data ", this.planType);
    // this.isIOSDevice = this.utilities.isDeviceiOS();
    // this.utilities.logEvent("View_Offer", {});
    // this.storage.get("localData").then(val => {
    //   let data = this.utilities.parseJSON(val);
    //   if(data.otherMaster.weight[0].param == "pound"){
    //       this.profileData.suggestedWeight= Math.round(parseInt(data.otherMaster.bmi.suggestedWeight) / this.poundValue);
    //       this.unit = "pounds";
    //    }
    // })
    // this.countDown()
  }
  

  close() {
    let data = {};
    this.modalController.dismiss(data);
  }

  doActivate(flag, planId){
    let data = {
      isActivate: true,
      planId: planId
    };
    this.modalController.dismiss(data);
  }
}
